import { mapGetters } from 'vuex'
import Container from '@/components/Container/Container'
import Spinner from '@/components/Spinner/Spinner'
import Map from '@/components/Map/Map'
import FieldHorizontal from '@/components/FieldHorizontal/FieldHorizontal'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  name: 'Vehicle',
  components: {
    Container,
    FontAwesomeIcon,
    FieldHorizontal,
    Spinner,
    Map
  },
  computed: {
    ...mapGetters({
      isLoading: 'vehiclesLoading',
      error: 'vehiclesError',
      vehicle: 'vehicle',
      sessionData: 'sessionData'
    })
  },data() {
    return {
      editable: false,
      changes: {}
    }
  },
  created() {
    const vehicleId = this.$route.params.id
    this.getVehicle(vehicleId)
  },
  methods: {
    getVehicle(vehicleId) {
      this.$store.commit('CLEAR_SESSION')
      this.$store.dispatch('getVehicle', vehicleId).then(vehicle => {
        this.$store.dispatch('getSessionData', { session: vehicle.last_session.id })
      })
    },
    editVehicle() {
      this.$data.editable = true
    },
    updateVehicle(key, value) {
      this.$data.changes[key] = value
    },
    saveVehicle() {
      // Prep payload
      const payload = Object.assign({}, this.vehicle.vehicle, this.$data.changes)
      this.$store
        .dispatch('saveVehicle', payload)
        .then(() => {
          this.$data.editable = false
          this.$data.changes = {}
          // Fetch updated vehicle
          const vehicleId = this.$route.params.id
          this.getVehicle(vehicleId)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Vehicle/script.js